export default __webpack_public_path__ + "static/media/facebook.518b442c.svg";